.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: var(--space-10) var(--space-6);
}
.icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: var(--color-accent-soft);
  color: var(--color-accent-ink);
  display: grid;
  place-items: center;
}
.title {
  font-size: var(--text-lg);
  font-weight: 700;
}
.desc {
  color: var(--color-text-muted);
  max-width: 34rem;
  font-size: var(--text-sm);
}
.action {
  margin-block-start: 6px;
}
